import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'api';
import { PersonalDevelopmentPlan, CreatePDPRequest } from 'types/pdp';
import { API_PDP_CREATE } from 'constants/api';

export const createPDP = createAsyncThunk<
  PersonalDevelopmentPlan,
  { data: CreatePDPRequest }
>('pdp/createPDP', async ({ data }, { rejectWithValue }) =>
  api.axios
    .post(API_PDP_CREATE, data)
    .then((res) => res.data)
    .catch((e) => rejectWithValue(e.response?.data)),
);
